import { Controller } from 'stimulus';

class WishlistController extends Controller {
  onLikeClick(e) {
    e.preventDefault();

    const isLiked = this.element.classList.contains('is-liked');
    const removeFromView = this.data.has('removeFromView');
    const data = {
      modelId: parseInt(this.data.get('modelId'), 10),
      modelType: this.data.get('modelType'),
    };

    WishlistController[isLiked ? 'remove' : 'add'](data)
      .then(() => {
        this.element.classList[isLiked ? 'remove' : 'add']('is-liked');

        if (removeFromView) {
          this.element.closest('.journey-item').remove();
        }
      })
      .catch(() => {
        this.element.classList.remove('is-liked');

        WishlistController.showLoginModal();
      });
  }

  static showLoginModal() {
    $('#loginModal').modal('show');
  }

  /**
   * Add item to wishlist
   *
   * @param data
   * @returns Promise
   */
  static add(data) {
    return $.ajax({
      url: window.app.api.wishlistItem.store,
      method: 'POST',
      data: {
        _method: 'POST',
        model_id: data.modelId,
        model_type: data.modelType,
      },
    });
  }

  /**
   * Remove item from wishlist
   *
   * @param data
   * @returns Promise
   */
  static remove(data) {
    return $.ajax({
      url: window.app.api.wishlistItem.destroy,
      method: 'POST',
      data: {
        _method: 'DELETE',
        model_id: data.modelId,
        model_type: data.modelType,
      },
    });
  }
}

WishlistController.targets = [];

export default WishlistController;
